import React from 'react';

/**
 * Clickable Reference / Page-No chip.
 *
 * Clicking (or Enter/Space) opens the Order Forms page filtered to this
 * reference number **in a new browser tab**, leaving the current tab
 * undisturbed. Safe to drop inside clickable rows / cards / links — the
 * handler stops propagation and prevents the ancestor's default nav.
 *
 * The visual styling is fully controlled by the caller via ``className`` so
 * each page keeps its existing pill look; we only layer on the interaction
 * affordances (cursor, hover, focus ring).
 */
export function ReferenceChip({
  referenceNo,
  className = '',
  title,
  children,
  testId,
}) {
  if (referenceNo == null || referenceNo === '') return null;

  const open = (e) => {
    if (e) { e.stopPropagation(); e.preventDefault(); }
    window.open(
      `/orders?reference_no=${encodeURIComponent(referenceNo)}`,
      '_blank',
      'noopener,noreferrer',
    );
  };

  return (
    <span
      role="button"
      tabIndex={0}
      onClick={open}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') open(e);
      }}
      title={title || `Open ${referenceNo} in Order Forms (new tab)`}
      data-testid={testId || `reference-chip-${referenceNo}`}
      className={`cursor-pointer transition-[filter,background-color,box-shadow] duration-150 hover:brightness-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--gold-accent)] ${className}`}
    >
      {children}
    </span>
  );
}

export default ReferenceChip;
